// @core/api/endpoints/billing/get_billing_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BillingPolicyResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get billing policy
 * Returns a billing policy by ID.
 */
export async function GetBillingPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<BillingPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<BillingPolicyResponse>(requestPath, { ...requestOptions });
}
